import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/featured';

export default function FeaturedSection() {
  const [lead, ...rest] = featuredArticles;

  return (
    <section id="featured" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-fire-line" aria-hidden="true" />
              热门爆料
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              本周读者停留最久的内容
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              以下内容按阅读完成度排序，涵盖消费维权、科技内幕与财经观察三个方向，可作为了解网站内容风格的入口。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-7">
          <article className="lg:col-span-7 group flex flex-col rounded-lg overflow-hidden border border-background-300/60 bg-background-50">
            <div className="relative w-full h-56 md:h-80 overflow-hidden">
              <img
                src={lead.image}
                alt={`${lead.title} 配图`}
                title={`${lead.title} - 爆料官网`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-xs font-label px-3 py-1.5 rounded-md">
                <i className="ri-flashlight-fill" aria-hidden="true" />
                {lead.tag}
              </span>
            </div>
            <div className="flex flex-col gap-3 p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-3 text-xs font-label text-foreground-500">
                <span className="inline-flex items-center gap-1 text-primary-700">
                  <i className="ri-price-tag-3-line" aria-hidden="true" />
                  {lead.channel}
                </span>
                <span>{lead.date}</span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {lead.readCount.toLocaleString()}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {lead.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              <Link to="/channels" className="mt-1 inline-flex items-center gap-1.5 text-sm font-label text-primary-600 hover:text-primary-700 w-fit transition-colors">
                阅读全文
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-4">
            {rest.map((article) => (
              <article key={article.slug} className="group flex gap-4 rounded-lg border border-background-300/60 bg-background-50 p-3.5 md:p-4">
                <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={article.image}
                    alt={`${article.title} 配图`}
                    title={`${article.title} - 爆料官网`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-col gap-1.5 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 text-xs font-label text-foreground-500">
                    <span className="text-secondary-700">{article.channel}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" />
                      {article.readCount.toLocaleString()}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {article.title}
                  </h3>
                  <p className="hidden sm:block text-xs leading-relaxed text-foreground-600 line-clamp-2">{article.summary}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}